import AdminNotificationsService from "../services/adminNotifications.service";
import { requestAdminFcmToken, setupAdminForegroundPush } from "./firebaseMessaging";

export const registerAdminPushToken = async () => {
  if (localStorage.getItem("user_type") !== "admin") {
    return null;
  }

  if (!localStorage.getItem("session-id")) {
    return null;
  }

  try {
    const token = await requestAdminFcmToken();
    if (!token) {
      return null;
    }

    await AdminNotificationsService.updateAdminFcmToken(token);
    localStorage.setItem("admin_fcm_token", token);
    await setupAdminForegroundPush();
    console.log("[FCM] Admin push token saved to system_users.");
    return token;
  } catch (error) {
    console.error("[FCM] Failed to register admin push token:", error);
    return null;
  }
};
